import { render, staticRenderFns } from "./Englishbottom.vue?vue&type=template&id=62cf5be6&scoped=true&"
import script from "./Englishbottom.vue?vue&type=script&lang=js&"
export * from "./Englishbottom.vue?vue&type=script&lang=js&"
import style0 from "./Englishbottom.vue?vue&type=style&index=0&id=62cf5be6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cf5be6",
  null
  
)

export default component.exports